/**
 * @flow
 * @relayHash 6e4c5804f05b5e790120f36649cdc712
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteBatch} from 'relay-runtime';
export type CreateDeviceExportMutationVariables = {|
  export: {
    predicates?: ?any;
    condition?: ?string;
    fields?: ?$ReadOnlyArray<string>;
  };
|};
export type CreateDeviceExportMutationResponse = {|
  +deviceExportCreate: {|
    +id: string;
    +file: ?string;
    +fileSize: ?number;
    +error: ?string;
    +done: boolean;
    +createdAt: any;
  |};
|};
*/


/*
mutation CreateDeviceExportMutation(
  $export: DeviceExportInput!
) {
  deviceExportCreate(input: $export) {
    id
    file
    fileSize
    error
    done
    createdAt
  }
}
*/

const batch /*: ConcreteBatch*/ = {
  "fragment": {
    "argumentDefinitions": [
      {
        "kind": "LocalArgument",
        "name": "export",
        "type": "DeviceExportInput!",
        "defaultValue": null
      }
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "CreateDeviceExportMutation",
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "input",
            "variableName": "export",
            "type": "DeviceExportInput!"
          }
        ],
        "concreteType": "DeviceExport",
        "name": "deviceExportCreate",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "id",
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "file",
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "fileSize",
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "error",
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "done",
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "createdAt",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation"
  },
  "id": null,
  "kind": "Batch",
  "metadata": {},
  "name": "CreateDeviceExportMutation",
  "query": {
    "argumentDefinitions": [
      {
        "kind": "LocalArgument",
        "name": "export",
        "type": "DeviceExportInput!",
        "defaultValue": null
      }
    ],
    "kind": "Root",
    "name": "CreateDeviceExportMutation",
    "operation": "mutation",
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "input",
            "variableName": "export",
            "type": "DeviceExportInput!"
          }
        ],
        "concreteType": "DeviceExport",
        "name": "deviceExportCreate",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "id",
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "file",
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "fileSize",
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "error",
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "done",
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "createdAt",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "text": "mutation CreateDeviceExportMutation(\n  $export: DeviceExportInput!\n) {\n  deviceExportCreate(input: $export) {\n    id\n    file\n    fileSize\n    error\n    done\n    createdAt\n  }\n}\n"
};

module.exports = batch;
